export interface IProductFeatureState {
    isLoading: boolean;
    productFeatureData?: IProductFeature;
}

export const REQUEST_PRODUCT_FEATURE = "REQUEST_PRODUCT_FEATURE";
export const RECEIVE_PRODUCT_FEATURE = "RECEIVE_PRODUCT_FEATURE";

export interface IRequestProductFeatureAction {
    type: typeof REQUEST_PRODUCT_FEATURE;
}

export interface IReceiveProductFeatureAction {
    productFeatureData?: IProductFeature;
    type: typeof RECEIVE_PRODUCT_FEATURE;
}

export interface IProductFeature {
    IsBIRDActive?: boolean;
    BaselineFraudExposureReportEnabled?: boolean;
    OnlineIdentityVaultEnabled?: boolean;
    SecurityAssessmentEnabled?: boolean;
    HourPostIncidentLegalConsultationEnabled?: boolean;
    DiscountedBreachVictimServicesEnabled?: boolean;
    BreachReadinessKitEnabled?: boolean;
    ExpertProtectionTipsAndTimelyNewsEnabled?: boolean;
    AllowWhiteHawkAssessment?: boolean;
}

export type ProductFeatureTypes = IRequestProductFeatureAction | IReceiveProductFeatureAction;
